import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"#ff000f"} aria-hidden="true" aria-label="Answer logo" />;
};
